import { Button, Tooltip } from "@material-ui/core"
import { useStyles } from "./button-private-header-styles";
import { forwardRef } from "react";

interface ButtonIconProps {
    icon: JSX.Element;
    tooltip: string;
    onClick: () => any;
    className?: any;
    text?: string;
    disabled?: boolean;
}

export const ButtonPrivateHeader = forwardRef<HTMLButtonElement, ButtonIconProps>((props: ButtonIconProps, ref) => {
    const classes = useStyles();
    return (
        <>
            <Tooltip arrow title={props.tooltip} placement="right">
                <Button className={`${props.className ? props.className : classes.button}`} disabled={props.disabled} onClick={props.onClick} ref={ref}>
                    {props.icon}
                    {props.text}
                </Button>
            </Tooltip>
        </>
    )

})

